import React, { Component } from 'react';
import { Outlet } from 'react-router-dom';

import Separator from "@components/Separator";

import Footer from "./components/Footer";
import Sidebar from './components/Sidebar';
import styles from './researcherdashboard.module.css';

class ResearcherDashboard extends Component {
  render() {
    return (
      <div>
        <div className={styles.dashboard_container}>
          <Sidebar />

          <Outlet className={styles.dashboard_content} />

        </div>

        <div style={{ margin: "15%" }} />
        <Separator size="100%" />
        <Footer />
      </div>

    )
  }
}

export default ResearcherDashboard
